module.exports = {
  languages: {
    en: {
      origin: 'English',
      eng: 'English',
    },
    de: {
      origin: 'Deutsch',
      eng: 'German',
    },
    es: {
      origin: 'Español',
      eng: 'Spanish',
    },
    fr: {
      origin: 'Français',
      eng: 'French',
    },
    it: {
      origin: 'Italiano',
      eng: 'Italian',
    },
    nl: {
      origin: 'Nederlands',
      eng: 'Dutch',
    },
    no: {
      origin: 'Norsk',
      eng: 'Norwegian',
    },
    pl: {
      origin: 'Polski',
      eng: 'Polish',
    },
    pt: {
      origin: 'Português',
      eng: 'Portuguese',
    },
    ru: {
      origin: 'Русский',
      eng: 'Russian',
    },
    sv: {
      origin: 'Svenska',
      eng: 'Swedish',
    },
    ja: {
      origin: '日本語',
      eng: 'Japanese',
    },
    ko: {
      origin: '한국어',
      eng: 'Korean',
    },
    tr: {
      origin: 'Türkçe',
      eng: 'Turkish',
    },
    da: {
      origin: 'Dansk',
      eng: 'Danish',
    },
    hi: {
      origin: 'हिन्दी',
      eng: 'Hindi',
    },
    cs: {
      origin: 'Čeština',
      eng: 'Czech',
    },
    zh: {
      origin: '繁體中文',
      eng: 'Chinese',
    },
    th: {
      origin: 'ไทย',
      eng: 'Thai',
    },
    uk: {
      origin: 'Українська',
      eng: 'Ukrainian',
    },
    vi: {
      origin: 'Tiếng Việt',
      eng: 'Vietnamese',
    },
    id: {
      origin: 'Bahasa Indonesia',
      eng: 'Indonesian',
    },
    he: {
      origin: 'עברית',
      eng: 'Hebrew',
    },
  },
  supportedLanguages: [
    'en',
    'de',
    'es',
    'fr',
    'it',
    'nl',
    'no',
    'pl',
    'pt',
    'ru',
    'sv',
    'ja',
    'ko',
    'tr',
    'da',
    'hi',
    'cs',
    'th',
    'zh',
    'uk',
    'vi',
    'id',
  ],
  notExposedLanguages: [],
  fallbackLanguage: 'en',
  domains: {
    wix: 'www.wix.com',
    wixManaged: 'manage.wix.com',
    wixNaked: 'wix.com',
    wixUsers: 'users.wix.com',
  },
  fixedDomains: ['premium.wix.com'],
  linksToModify: {
    generalLinks: {
      become_wix_partner: 'localizedWixPartner',
      seo: 'localizedSeo',
      wix_marketplace: 'localizedMarketplace',
      shoutout: 'localizedMarketingEmail',
      ecommerce: 'localizedEcommerce',
      support: 'supportLinkLanguages',
      support_center: 'supportLinkLanguages',
      youtube: 'localizedSocialNetworks',
      facebook: 'localizedSocialNetworks',
      twitter: 'localizedSocialNetworks',
      tiktok: 'localizedSocialNetworks',
      affiliates: 'localizedAffiliates',
      patent_notice: 'localizedPatentNotice',
      app_market_terms: 'localizedAppMarkets',
      update_and_release: 'localizedReleaseNotes',
      footer_mailboxes: 'localizedFooterMailboxes',
      web_hosting: 'localizedFooterHosting',
      footer_design: 'localizedFooterDesign',
      student: 'localizedFooterStudent',
      logo_maker: 'localizedLogoMaker',
      hire_partner: 'localizedHirePartner',
      app_market: 'localizedAppMarket',
      sitemap: 'localizedSitemap',
      explore: 'localizedExplore',
      partner_community: 'localizedPartnerCommunity',
      templates: 'localizedTemplates',
      features: 'localizedFeatures',
      about: 'localizedAbout',
      design_assets: 'localizedDesignAssets',
      terms_of_use: 'localizedTermOfUse',
      privacy: 'localizedPrivacy',
      a11y: 'localizedA11y',
      contact_us: 'localizedContactUs',
      press_room: 'localizedPressRoom',
      web_accesibility: 'localizedWebAccesibility',
      wix_blog: 'localizedWixBlog',
      start_blog: 'localizedStartBlog',
      velo: 'localizedVelo',
    },
    userLinks: {
      upgrade_plans: 'premiumPlans',
      domains: 'localizedDomain',
      mailboxes: 'mailboxes',
    },
  },
  linkModifiers: {
    localizedContactUs: {
      vi: 'https://www.wix.com/about/contact-us',
      id: 'https://www.wix.com/about/contact-us',
    },
    localizedA11y: {
      vi: 'https://www.wix.com/about/terms-accessibility',
      id: 'https://www.wix.com/about/terms-accessibility',
    },
    localizedPrivacy: {
      vi: 'https://www.wix.com/about/privacy',
      id: 'https://www.wix.com/about/privacy',
    },
    localizedTermOfUse: {
      vi: 'https://www.wix.com/about/terms-of-use',
      id: 'https://www.wix.com/about/terms-of-use',
    },
    localizedDesignAssets: {
      vi: 'https://www.wix.com/about/design-assets',
      id: 'https://www.wix.com/about/design-assets',
    },
    localizedAbout: {
      vi: 'https://www.wix.com/about/us',
      id: 'https://www.wix.com/about/us',
    },
    localizedTemplates: {
      vi: 'https://www.wix.com/website/templates',
      id: 'https://www.wix.com/website/templates',
    },
    localizedLogoMaker: {
      fr: 'https://fr.wix.com/logo/creer-logo',
      pt: 'https://pt.wix.com/logo/criar-logo',
      de: 'https://de.wix.com/logo/erstellen',
      uk: 'https://www.wix.com/logo/maker',
      vi: 'https://www.wix.com/logo/maker',
      id: 'https://www.wix.com/logo/maker',
      it: 'https://it.wix.com/logo/creare-logo',
    },
    localizedSitemap: {
      th: 'https://www.wix.com/about/sitemap',
      uk: 'https://www.wix.com/about/sitemap',
      zh: 'https://www.wix.com/about/sitemap',
      vi: 'https://www.wix.com/about/sitemap',
      id: 'https://www.wix.com/about/sitemap',
    },
    localizedExplore: {
      uk: 'https://www.wix.com/explore/websites',
      vi: 'https://www.wix.com/explore/websites',
      id: 'https://www.wix.com/explore/websites',
    },
    localizedFeatures: {
      vi: 'https://www.wix.com/features/main',
      id: 'https://www.wix.com/features/main',
    },
    localizedFooterStudent: {
      en: 'https://www.wix.com/students',
      es: 'https://es.wix.com/students',
      fr: 'https://fr.wix.com/students',
      de: 'https://de.wix.com/students',
      nl: 'https://nl.wix.com/students',
      it: 'https://it.wix.com/students',
    },
    localizedFooterDesign: {
      en: 'https://www.wix.com/website/design',
      es: 'https://es.wix.com/diseno/web',
      de: 'https://de.wix.com/website/design',
      ru: 'https://ru.wix.com/dizayn/sayta',
    },
    localizedWixBlog: {
      en: 'https://www.wix.com/blog',
      cs: 'https://www.wix.com/blog',
      da: 'https://www.wix.com/blog',
      de: 'https://de.wix.com/blog',
      es: 'https://es.wix.com/blog',
      fr: 'https://fr.wix.com/blog',
      hi: 'https://www.wix.com/blog',
      id: 'https://www.wix.com/blog',
      it: 'https://it.wix.com/blog',
      ja: 'https://ja.wix.com/blog',
      ko: 'https://ko.wix.com/blog',
      nl: 'https://nl.wix.com/blog',
      no: 'https://www.wix.com/blog',
      pl: 'https://pl.wix.com/blog',
      pt: 'https://pt.wix.com/blog',
      ru: 'https://ru.wix.com/blog',
      sv: 'https://www.wix.com/blog',
      th: 'https://www.wix.com/blog',
      tr: 'https://tr.wix.com/blog',
      uk: 'https://www.wix.com/blog',
      vi: 'https://www.wix.com/blog',
      zh: 'https://www.wix.com/blog',
      zu: 'https://www.wix.com/blog',
    },
    localizedStartBlog: {
      en: 'https://www.wix.com/start/blog',
      cs: 'https://cs.wix.com/start/blog',
      da: 'https://da.wix.com/start/lav-en-blog',
      de: 'https://de.wix.com/start/blog-erstellen',
      es: 'https://es.wix.com/start/crear-blog',
      fr: 'https://fr.wix.com/start/creer-blog',
      hi: 'https://hi.wix.com/start/blog',
      id: 'https://www.wix.com/start/blog',
      it: 'https://it.wix.com/start/creare-un-blog',
      ja: 'https://ja.wix.com/start/blog-kaisetsu',
      ko: 'https://ko.wix.com/start/beullogeu-mandeulgi',
      nl: 'https://nl.wix.com/start/blog-maken',
      no: 'https://no.wix.com/start/lag-blogg',
      pl: 'https://pl.wix.com/start/jak-zalozyc-bloga',
      pt: 'https://pt.wix.com/start/criar-blog',
      ru: 'https://ru.wix.com/start/sozdat-blog',
      sv: 'https://sv.wix.com/start/starta-blogg',
      th: 'https://th.wix.com/start/blog',
      tr: 'https://tr.wix.com/start/blog-nasil-acilir',
      uk: 'https://www.wix.com/start/blog',
      vi: 'https://www.wix.com/start/blog',
      zh: 'https://zh.wix.com/start/blog',
      zu: 'https://www.wix.com/start/blog',
    },
    localizedEcommerce: {
      es: 'https://es.wix.com/ecommerce/tienda-online',
      fr: 'https://fr.wix.com/ecommerce/site-vente-en-ligne',
      pt: 'https://pt.wix.com/ecommerce/loja-virtual',
      ja: 'https://ja.wix.com/ecommerce/netshop',
      de: 'https://de.wix.com/ecommerce/onlineshop-erstellen',
      ru: 'https://ru.wix.com/ecommerce/internet-magazin ',
      sv: 'https://sv.wix.com/ecommerce/starta-webshop ',
      it: 'https://it.wix.com/ecommerce/negozio-online',
      no: 'https://no.wix.com/ecommerce/starte-nettbutikk',
      nl: 'https://nl.wix.com/ecommerce/webshop-maken',
      pl: 'https://pl.wix.com/ecommerce/sklep-internetowy',
      tr: 'https://tr.wix.com/ecommerce/eticaret-sitesi',
      uk: 'https://uk.wix.com/ecommerce/website',
      vi: 'https://www.wix.com/ecommerce/website',
      id: 'https://www.wix.com/ecommerce/website',
    },
    localizedMarketingEmail: {
      de: 'https://de.wix.com/ascend/email-marketing',
      fr: 'https://fr.wix.com/ascend/email-marketing',
      es: 'https://es.wix.com/ascend/email-marketing',
      pt: 'https://pt.wix.com/ascend/email-marketing',
      ja: 'https://ja.wix.com/ascend/email-marketing',
      ru: 'https://ru.wix.com/ascend/email-marketing',
      zh: 'https://zh.wix.com/shoutout/email-marketing',
      tr: 'https://tr.wix.com/ascend/email-marketing',
      da: 'https://da.wix.com/ascend/email-marketing',
      nl: 'https://nl.wix.com/ascend/email-marketing',
      no: 'https://no.wix.com/ascend/email-marketing',
      it: 'https://it.wix.com/ascend/email-marketing',
      cs: 'https://cs.wix.com/ascend/email-marketing',
      sv: 'https://sv.wix.com/ascend/email-marketing',
      th: 'https://th.wix.com/ascend/email-marketing',
      pl: 'https://pl.wix.com/ascend/email-marketing',
    },
    localizedHirePartner: {
      fr: 'https://fr.wix.com/marketplace?utm_source=hp-menu',
      es: 'https://es.wix.com/marketplace?utm_source=hp-menu',
      pt: 'https://pt.wix.com/marketplace?utm_source=hp-menu',
      de: 'https://de.wix.com/marketplace?utm_source=hp-menu',
      it: 'https://it.wix.com/marketplace?utm_source=hp-menu',
      nl: 'https://nl.wix.com/marketplace?utm_source=hp-menu',
      ja: 'https://ja.wix.com/marketplace?utm_source=hp-menu',
    },

    localizedMarketplace: {
      fr: 'https://fr.wix.com/marketplace',
      es: 'https://es.wix.com/marketplace',
      ja: 'https://ja.wix.com/marketplace',
      pt: 'https://pt.wix.com/marketplace',
      de: 'https://de.wix.com/marketplace',
      it: 'https://it.wix.com/marketplace',
      nl: 'https://nl.wix.com/marketplace',
      tr: 'https://tr.wix.com/marketplace',
      da: 'https://da.wix.com/marketplace',
      no: 'https://no.wix.com/marketplace',
      cs: 'https://cs.wix.com/marketplace',
      sv: 'https://sv.wix.com/marketplace',
      th: 'https://th.wix.com/marketplace',
      ko: 'https://ko.wix.com/marketplace',
      ru: 'https://ru.wix.com/marketplace',
      pl: 'https://pl.wix.com/marketplace',
    },
    localizedSeo: {
      en: 'https://www.wix.com/seo',
      ru: 'https://ru.wix.com/seo',
      uk: 'https://uk.wix.com/seo',
      tr: 'https://tr.wix.com/seo',
      vi: 'https://www.wix.com/seo',
      id: 'https://www.wix.com/seo',
      da: 'https://da.wix.com/seo',
      pt: 'https://pt.wix.com/seo',
      fr: 'https://fr.wix.com/seo',
      it: 'https://it.wix.com/seo',
      es: 'https://es.wix.com/seo',
      cs: 'https://cs.wix.com/seo',
      sv: 'https://sv.wix.com/seo',
      ja: 'https://ja.wix.com/seo',
      de: 'https://de.wix.com/seo',
      ko: 'https://ko.wix.com/seo',
      th: 'https://th.wix.com/seo',
      pl: 'https://pl.wix.com/seo',
    },
    localizedAffiliates: {
      da: 'https://www.wix.com/about/affiliates',
      hi: 'https://www.wix.com/about/affiliates',
      cs: 'https://www.wix.com/about/affiliates',
      zh: 'https://www.wix.com/about/affiliates',
      th: 'https://www.wix.com/about/affiliates',
      uk: 'https://www.wix.com/about/affiliates',
      vi: 'https://www.wix.com/about/affiliates',
      id: 'https://www.wix.com/about/affiliates',
    },
    localizedReleaseNotes: {
      da: 'https://www.wix.com/release/notes',
      hi: 'https://www.wix.com/release/notes',
      cs: 'https://www.wix.com/release/notes',
      zh: 'https://www.wix.com/release/notes',
      th: 'https://www.wix.com/release/notes',
      uk: 'https://www.wix.com/release/notes',
      vi: 'https://www.wix.com/release/notes',
      id: 'https://www.wix.com/release/notes',
      tr: 'https://www.wix.com/release/notes',
    },
    localizedAppMarkets: {
      no: 'https://www.wix.com/about/app-market-terms',
      sv: 'https://www.wix.com/about/app-market-terms',
      da: 'https://www.wix.com/about/app-market-terms',
      hi: 'https://www.wix.com/about/app-market-terms',
      cs: 'https://www.wix.com/about/app-market-terms',
      uk: 'https://www.wix.com/about/app-market-terms',
      vi: 'https://www.wix.com/about/app-market-terms',
      id: 'https://www.wix.com/about/app-market-terms',
    },
    localizedPatentNotice: {
      zh: 'https://www.wix.com/about/patent-notice',
      th: 'https://www.wix.com/about/patent-notice',
      vi: 'https://www.wix.com/about/patent-notice',
      id: 'https://www.wix.com/about/patent-notice',
    },
    localizedSocialNetworks: {
      facebook: {
        es: 'https://www.facebook.com/WixEspanol',
        fr: 'https://www.facebook.com/WixFrancais',
        pt: 'https://www.facebook.com/WixPortugues',
        ja: 'https://www.facebook.com/WixJapan',
        de: 'https://www.facebook.com/WixDeutsch',
      },
      twitter: {
        es: 'https://twitter.com/MundoWix',
        fr: 'https://twitter.com/WixFrance',
        pt: 'https://twitter.com/WixBR',
        ja: 'https://twitter.com/WixJp',
      },
      youtube: {
        es: 'https://www.youtube.com/channel/UCDRKTtETGequA8pLwIn-Nlg',
        fr: 'https://www.youtube.com/channel/UCy7ONifkKb8_cWLWgjub7Mg',
        pt: 'https://www.youtube.com/channel/UCE54ruEdx6thRYmD3Qbv3cA',
        ja: 'https://www.youtube.com/channel/UCQ9DrfzWn7kpQVlr0Zgj67w',
        de: 'https://www.youtube.com/channel/UCcuUenS9HPRVQyPPkH6yu5A',
        it: 'https://www.youtube.com/channel/UCU9d62kabPCxAWQEqoL8jWA',
        ru: 'https://www.youtube.com/channel/UCm9VYDcIJEqwxlnK3bxhT9w',
        tr: 'https://www.youtube.com/channel/UCTC-mHCu9DRpxh6Z3a96mbg',
        ko: 'https://www.youtube.com/channel/UCU2llu2kjl4xk_V1i9ArR3Q',
      },
      tiktok: {
        en: 'https://www.tiktok.com/@wix',
        de: 'https://www.tiktok.com/@wix',
        es: 'https://www.tiktok.com/@wix',
        fr: 'https://www.tiktok.com/@wix',
        it: 'https://www.tiktok.com/@wix',
        nl: 'https://www.tiktok.com/@wix',
        no: 'https://www.tiktok.com/@wix',
        pl: 'https://www.tiktok.com/@wix',
        pt: 'https://www.tiktok.com/@wix',
        ru: 'https://www.tiktok.com/@wix',
        sv: 'https://www.tiktok.com/@wix',
        ja: 'https://www.tiktok.com/@wix',
        ko: 'https://www.tiktok.com/@wix',
        tr: 'https://www.tiktok.com/@wix',
        da: 'https://www.tiktok.com/@wix',
        hi: 'https://www.tiktok.com/@wix',
        cs: 'https://www.tiktok.com/@wix',
        th: 'https://www.tiktok.com/@wix',
        zh: 'https://www.tiktok.com/@wix',
        uk: 'https://www.tiktok.com/@wix',
        vi: 'https://www.tiktok.com/@wix',
        id: 'https://www.tiktok.com/@wix',
      },
    },
    localizedDomain: {
      loggedIn: 'https://premium.wix.com/wix/api/domainConsole',
      anonymous: {
        es: 'https://es.wix.com/dominio/gratis',
        de: 'https://de.wix.com/domain/check',
        fr: 'https://fr.wix.com/nom-de-domaine/gratuit',
        pt: 'https://pt.wix.com/dominio/gratis',
        uk: 'https://www.wix.com/domain/names',
        vi: 'https://www.wix.com/domain/names',
        id: 'https://www.wix.com/domain/names',
      },
    },
    mailboxes: {
      loggedIn: 'https://premium.wix.com/wix/api/googleMailBoxConsole',
    },
    premiumPlans: {
      loggedIn: 'https://premium.wix.com/wix/api/billingConsole',
      anonymous: {
        vi: 'https://www.wix.com/upgrade/website',
        id: 'https://www.wix.com/upgrade/website',
      },
    },
    supportLinkLanguages: {
      de: 'https://support.wix.com/de/',
      es: 'https://support.wix.com/es/',
      fr: 'https://support.wix.com/fr/',
      it: 'https://support.wix.com/it/',
      ja: 'https://support.wix.com/ja/',
      ko: 'https://support.wix.com/ko/',
      pt: 'https://support.wix.com/pt/',
      ru: 'https://support.wix.com/ru/',
      tr: 'https://support.wix.com/tr/',
      pl: 'https://support.wix.com/pl/',
      nl: 'https://support.wix.com/nl/',
      da: 'https://support.wix.com/da/',
      no: 'https://support.wix.com/no/',
      sv: 'https://support.wix.com/sv/',
    },
    localizedFooterMailboxes: {
      es: 'https://es.wix.com/profesional/correo-empresarial',
      de: 'https://de.wix.com/business/eigene-email-domain',
      fr: 'https://fr.wix.com/adresse-email/professionnelle',
      it: 'https://it.wix.com/email/professionale',
      ja: 'https://ja.wix.com/business/email-address',
      ko: 'https://ko.wix.com/about/mailboxes',
      nl: 'https://nl.wix.com/zakelijke/e-mail',
      pl: 'https://pl.wix.com/poczta/firmowa',
      pt: 'https://pt.wix.com/email/profissional',
      ru: 'https://ru.wix.com/korporativnaya/pochta',
      tr: 'https://tr.wix.com/kurumsal/e-posta',
      sv: 'https://sv.wix.com/about/mailboxes',
      no: 'https://no.wix.com/about/mailboxes',
      hi: 'https://hi.wix.com/about/mailboxes',
      da: 'https://da.wix.com/business/email-address',
      zh: 'https://zh.wix.com/business/email-address',
      cs: 'https://cs.wix.com/business/email-address',
      th: 'https://th.wix.com/business/email-address',
    },
    localizedFooterHosting: {
      it: 'https://it.wix.com/free/web-hosting',
      fr: 'https://fr.wix.com/hebergement/gratuit',
      uk: 'https://uk.wix.com/free/web-hosting',
      ru: 'https://ru.wix.com/besplatnyj-hosting',
      de: 'https://de.wix.com/hosting',
      nl: 'https://nl.wix.com/webhosting/',
      pl: 'https://pl.wix.com/darmowy/hosting',
      da: 'https://da.wix.com/webhosting',
      pt: 'https://pt.wix.com/hospedagem-de-site/gratis',
      es: 'https://es.wix.com/hosting/gratis',
      tr: 'https://tr.wix.com/ucretsiz/hosting',
      cs: 'https://cs.wix.com/free/web-hosting',
      no: 'https://no.wix.com/gratis/webhotell',
      sv: 'https://sv.wix.com/webbhotell',
      th: 'https://th.wix.com/free/web-hosting',
      ja: 'https://ja.wix.com/free/web-hosting',
      ko: 'https://ko.wix.com/free/web-hosting',
      zh: 'https://zh.wix.com/free/web-hosting',
    },
    localizedAppMarket: {
      en: 'https://www.wix.com/app-market',
      vi: 'https://www.wix.com/app-market',
      id: 'https://www.wix.com/app-market',
    },
    localizedPartnerCommunity: {
      ja: 'https://community.wix.com/ja/partners',
    },
    localizedWixPartner: {
      nl: 'https://nl.wix.com/partners',
      ja: 'https://ja.wix.com/partners',
    },
    localizedPressRoom: {
      ja: 'https://ja.wix.com/press-room',
    },
    localizedWebAccesibility: {
      ja: 'https://ja.wix.com/accessibility',
      tr: 'https://tr.wix.com/accessibility',
      fr: 'https://fr.wix.com/accessibility',
      es: 'https://es.wix.com/accessibility',
      ru: 'https://ru.wix.com/accessibility',
      de: 'https://de.wix.com/accessibility',
      it: 'https://it.wix.com/accessibility',
      nl: 'https://nl.wix.com/accessibility',
      pl: 'https://pl.wix.com/accessibility',
      pt: 'https://pt.wix.com/accessibility',
      ko: 'https://ko.wix.com/accessibility',
    },
    localizedVelo: {
      fr: 'https://fr.wix.com/velo',
      pt: 'https://pt.wix.com/velo',
      de: 'https://de.wix.com/velo',
      es: 'https://es.wix.com/velo',
      ja: 'https://ja.wix.com/velo',
    },
  },
  socialNetworks: ['facebook', 'twitter', 'youtube', 'pinterest', 'instagram', 'linkedin', 'tiktok'],
  scrollDropdownWhenItemsAmountIsBiggerThen: 12,
  defaultScreenBreakpoint: 750,
  a11yScreenBreakpoint: 980,
  defaultTabIndex: [1, 0],
};
